// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"e0429c7f1a0219c3ff39","452":"0ff975c8e5ad9c82f207","453":"be7a689b17b8592a1909","522":"22ce75a6b1ed77b7ebc2","551":"bd883e99ab59c8c01015"}[chunkId] + ".js";
};